const angular = require('angular');
var app = angular.module('learn-controllers');
const moment = require('moment');

app.controller('overviewJourneys', ['Application', 'AccessHelper', function(Application, AccessHelper) {
    var self = this;
    self.features = Application.features.flags();
    if (!self.features.journeys && !AccessHelper.allowGeneralActivity('journeys', ['admin', 'creator'])) {
        Application.navigation.goTo('/explore');
        return;
    }
}]);